import '@a-type/ui/main.css';
import '@biscuits/client/global.css';
import './main.css';

import { Provider as UIProvider } from '@a-type/ui';
import { AppId, appsById } from '@biscuits/apps';
import { Provider } from '@biscuits/client';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { client } from './graphql.js';
import { router } from './router.js';

function main() {
	const root = createRoot(document.getElementById('root')!);
	root.render(
		<StrictMode>
			<UIProvider>
				<Provider graphqlClient={client} router={router}>
					<RouterProvider router={router} />
				</Provider>
			</UIProvider>
		</StrictMode>,
	);
}

main();

function handleAppState(handler: (appState: any) => void) {
	const appState = new URLSearchParams(window.location.search).get('appState');
	if (appState) {
		handler(JSON.parse(appState));
	}
}
handleAppState((appState) => {
	if (appState?.appReferrer) {
		const app = appsById[appState.appReferrer as AppId];
		if (!app) return;

		const returnToPath = appState?.appReturnTo ?? '/';
		const url = new URL(
			returnToPath,
			import.meta.env.DEV ? app.devOriginOverride : app.url,
		);
		window.location.href = url.toString();
	}
});
